/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { COINSharedApplicationProtosResponsesStatusResponse } from '@coin/shared/core/util-models';
import { EmployeesAresAreModel } from '@coin/shared/core/util-models';
import { EmployeesAresCreateAreModel } from '@coin/shared/core/util-models';
import { EmployeesAresUpdateAreModel } from '@coin/shared/core/util-models';
import { EmployeesBenchmarkSettingsBenchmarkSettingsModel } from '@coin/shared/core/util-models';
import { EmployeesBenchmarkSettingsCreateBenchmarkSettingsModel } from '@coin/shared/core/util-models';
import { EmployeesBenchmarkSettingsUpdateBenchmarkSettingsModel } from '@coin/shared/core/util-models';
import { EmployeesColoradosColoradoModel } from '@coin/shared/core/util-models';
import { EmployeesEmployeeInCompanyManagerUpdateEmployeeInCompanyManagerModel } from '@coin/shared/core/util-models';
import { EmployeesEmployeeLineManagerUpdateEmployeeLineManagerModel } from '@coin/shared/core/util-models';
import { EmployeesEmployeesEmployeeInternalLevelModel } from '@coin/shared/core/util-models';
import { EmployeesEmployeesEmployeeModel } from '@coin/shared/core/util-models';
import { EmployeesEmployeesFullEmployeeForReorgAppModel } from '@coin/shared/core/util-models';
import { EmployeesEmployeesFullEmployeeModel } from '@coin/shared/core/util-models';
import { EmployeesEmployeesQueryEmployeesByRuleSetParameter } from '@coin/shared/core/util-models';
import { EmployeesEmployeesQueryEmployeesWithExcludableGidsParameter } from '@coin/shared/core/util-models';
import { EmployeesInternalCommentsInternalCommentModel } from '@coin/shared/core/util-models';
import { EmployeesInternalCommentsUpdateInternalCommentModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodeAssignmentsCreateMercerJobCodeAndPositionClassAssignmentModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentLightModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodeAssignmentsMercerJobCodeAssignmentLightModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodeAssignmentsMercerPositionClassAssignmentLightModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodeAssignmentsUpdateMercerJobCodeAssignmentModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodeAssignmentsUpdateMercerPositionClassAssignmentModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodesJobProfileValuesModel } from '@coin/shared/core/util-models';
import { EmployeesMercerJobCodesMercerJobCodeModel } from '@coin/shared/core/util-models';
import { EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel } from '@coin/shared/core/util-models';
import { EmployeesSecuritySettingsCreateSecuritySettingsModel } from '@coin/shared/core/util-models';
import { EmployeesSecuritySettingsPopulationSimulationPageModel } from '@coin/shared/core/util-models';
import { EmployeesSecuritySettingsSecuritySettingsModel } from '@coin/shared/core/util-models';
import { EmployeesSecuritySettingsUpdateSecuritySettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPrioritiesChangeManyPrioritiesModel } from '@coin/shared/core/util-models';
import { SharedEntitySearchScopeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesAresAreModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesBenchmarkSettingsBenchmarkSettingsModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesEmployeesEmployeeDirectModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesEmployeesEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesEmployeesFullEmployeeForReorgAppModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesEmployeesFullEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesMercerJobCodeAssignmentsMercerEmployeesWithAssignmentsModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesMercerJobCodesMercerJobCodeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSharedFieldValueWithDescriptionModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSystemString } from '@coin/shared/core/util-models';
import { SharedRuleEngineRuleSetModel } from '@coin/shared/core/util-models';
import { SiemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersCreateRuleBasedAccessFilterCommand } from '@coin/shared/core/util-models';
import { SiemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersUpdateRuleBasedAccessFilterCommand } from '@coin/shared/core/util-models';
import { SiemensEnergyCOINClientApiRequestsEmployeesEmployeesUpdateEmployeeInternalLevelCommand } from '@coin/shared/core/util-models';
import { TransactionStatusOfBenchmarkAssignmentMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData } from '@coin/shared/core/util-models';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface EmployeesAdminServiceAssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeRequestParams {
  ruleId: string;
  employeeId: string;
}

export interface EmployeesAdminServiceChangePrioritiesBenchmarkSettingsRequestParams {
  /** The model containing all priorities to change. */
  seasonsPrioritiesChangeManyPrioritiesModel?: SeasonsPrioritiesChangeManyPrioritiesModel;
}

export interface EmployeesAdminServiceCreateAresRequestParams {
  /** The model to create a new are with. */
  employeesAresCreateAreModel?: EmployeesAresCreateAreModel;
}

export interface EmployeesAdminServiceCreateBenchmarkSettingsRequestParams {
  /** The model to create the new banchmark settings with. */
  employeesBenchmarkSettingsCreateBenchmarkSettingsModel?: EmployeesBenchmarkSettingsCreateBenchmarkSettingsModel;
}

export interface EmployeesAdminServiceCreateMercerJobCodeAssignmentsRequestParams {
  /** The model data to create the assignments with. */
  employeesMercerJobCodeAssignmentsCreateMercerJobCodeAndPositionClassAssignmentModel?: EmployeesMercerJobCodeAssignmentsCreateMercerJobCodeAndPositionClassAssignmentModel;
}

export interface EmployeesAdminServiceCreateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams {
  /** Command Model with metadata to create RuleBasedAccessFilter */
  siemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersCreateRuleBasedAccessFilterCommand?: SiemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersCreateRuleBasedAccessFilterCommand;
}

export interface EmployeesAdminServiceCreateSecuritySettingsRequestParams {
  /** The model data to create new security settings with. */
  employeesSecuritySettingsCreateSecuritySettingsModel?: EmployeesSecuritySettingsCreateSecuritySettingsModel;
}

export interface EmployeesAdminServiceDeleteAresRequestParams {
  /** The unique id of the are to delete. */
  id: string;
}

export interface EmployeesAdminServiceDeleteRuleBasedAccessFilterRuleBasedAccessFilterRequestParams {
  /**  */
  ruleId: string;
}

export interface EmployeesAdminServiceDeleteSecuritySettingsRequestParams {
  /** The unique id of the security settings to delete. */
  id: string;
}

export interface EmployeesAdminServiceExportEmployeesExpertsDataEmployeesExpertsRequestParams {
  fileName?: string;
  transactionId?: string;
}

export interface EmployeesAdminServiceExportJobAssignmentsDatahubRequestParams {
  exportS3?: boolean;
  exportDataHub?: boolean;
}

export interface EmployeesAdminServiceExportJobCodesDatahubRequestParams {
  exportS3?: boolean;
  exportDataHub?: boolean;
}

export interface EmployeesAdminServiceGetAresRequestParams {
  /** The unique id of the are to find. */
  id: string;
}

export interface EmployeesAdminServiceGetByGidEmployeesRequestParams {
  /** The unique gid of the employee to get. */
  gid: string;
}

export interface EmployeesAdminServiceGetColoradosRequestParams {
  /** The unique id of the colorado to find. */
  id: string;
}

export interface EmployeesAdminServiceGetCountEmployeesRequestParams {
  /** The rule set to use to filter employees. */
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface EmployeesAdminServiceGetEmployeeInternalLevelRequestParams {
  /** The unique id of the employee to get the internal level of. */
  employeeId: string;
}

export interface EmployeesAdminServiceGetEmployeeRowLevelSecurityRequestParams {
  /** The unique of the employee. */
  id: string;
}

export interface EmployeesAdminServiceGetEmployeeWithCompensationsRequestParams {
  /** The unique id of the employee to get. */
  id: string;
}

export interface EmployeesAdminServiceGetEmployeesRequestParams {
  /** The unique id of the employee to get. */
  id: string;
}

export interface EmployeesAdminServiceGetInternalCommentsRequestParams {
  employeeId: string;
}

export interface EmployeesAdminServiceGetMercerJobCodesRequestParams {
  /** The unique id of the mercer job code to get. */
  id: string;
}

export interface EmployeesAdminServiceGetSecuritySettingsRequestParams {
  /** The unique id of the security settings to get. */
  id: string;
}

export interface EmployeesAdminServicePostAssignmentsExportMercerJobCodeAssignmentsExportRequestParams {
  /** The gid of the mercer job assignment. */
  gid?: Array<string>;
  /** The last name of the mercer job assignment. */
  lastname?: string;
  /** The first name of the mercer job assignment. */
  firstname?: string;
  /** The org code of the mercer job assignment. */
  orgCodes?: Array<string>;
  /** The org size of the mercer job assignment. */
  orgSizes?: Array<number>;
  /** The country of the mercer job assignment. */
  countries?: Array<string>;
  /** The are of the mercer job assignment. */
  areCodes?: Array<string>;
  /** The job code of the mercer job assignment. */
  jobCodes?: Array<string>;
  /** The family of the mercer job assignment. */
  familyNames?: Array<string>;
  /** The sub family of the mercer job assignment. */
  subFamilyNames?: Array<string>;
  /** The specialization of the mercer job assignment. */
  specializationNames?: Array<string>;
  /** The career level of the mercer job assignment. */
  careerLevelNames?: Array<string>;
  /** The career stream of the mercer job assignment. */
  careerStreams?: Array<string>;
  /** The position class of the mercer job assignment. */
  positionClasses?: Array<number>;
  /** The internal level of the mercer job assignment. */
  internalLevels?: Array<string>;
  /** The job code valid from date of the mercer assignment. */
  jobCodeValidFrom?: string;
  /** The job code valid to date of the mercer assignment. */
  jobCodeValidTo?: string;
  /** The job code validated of the mercer assignment. */
  jobCodeIsValidated?: Array<boolean>;
  /** The position class valid from date of the mercer assignment. */
  positionClassValidFrom?: string;
  /** The position class valid to date of the mercer assignment. */
  positionClassValidTo?: string;
  /** The position class validated of the mercer assignment. */
  positionClassIsValidated?: Array<boolean>;
  /** The additional create export model. */
  employeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModel?: EmployeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModel;
}

export interface EmployeesAdminServiceQueryAresRequestParams {
  page?: number;
  size?: number;
  /** The search text to find. */
  searchQuery?: string;
  /** The country\&#39;s ISO2 code to find. */
  countryCode?: string;
}

export interface EmployeesAdminServiceQueryBenchmarkSettingsRequestParams {
  page?: number;
  size?: number;
}

export interface EmployeesAdminServiceQueryByEmployeeMercerJobCodeAssignmentsRequestParams {
  /** The unique gid of the employee to query assignments for. */
  gid: string;
}

export interface EmployeesAdminServiceQueryBySearchEmployeesRequestParams {
  page?: number;
  size?: number;
  /** Search parameter. */
  search?: string;
}

export interface EmployeesAdminServiceQueryDirectsInCompanyManagersRequestParams {
  /** Optional unique id of the in company manager to find directs of. */
  id?: string;
  /** Optional gid of the in company manager to find directs of. */
  gid?: string;
  page?: number;
  size?: number;
}

export interface EmployeesAdminServiceQueryDirectsLineManagersRequestParams {
  /** Optional unique id of the line manager to find directs of. */
  id?: string;
  /** Optional gid of the line manager to find directs of. */
  gid?: string;
  /** The search text to filter directs with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface EmployeesAdminServiceQueryEmployeeRowLevelSecurityRequestParams {
  /** The gid to find. */
  gid?: string;
  /** The name to find. */
  name?: string;
  /** The orgcode to find. */
  orgCode?: string;
  /** The contract state values to filter for. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
}

export interface EmployeesAdminServiceQueryEmployeesRequestParams {
  /** The gid to find. */
  gid?: string;
  /** The name to find. */
  name?: string;
  /** The firstname to find. */
  firstname?: string;
  /** The lastname to find. */
  lastname?: string;
  /** The place of action to find. */
  placeOfAction?: Array<string>;
  /** The orgcode to find. */
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface EmployeesAdminServiceQueryEmployeesEmployeesRequestParams {
  /** The query parameters and rule set to query employees with. */
  employeesEmployeesQueryEmployeesByRuleSetParameter?: EmployeesEmployeesQueryEmployeesByRuleSetParameter;
}

export interface EmployeesAdminServiceQueryFieldValuesEmployeesRequestParams {
  /** The name of the field to get values for. */
  fieldname: string;
}

export interface EmployeesAdminServiceQueryFieldValuesMercerJobCodeAssignmentsRequestParams {
  /** The target property of the mercer job code assignment. */
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18;
  /** The organization code of the mercer job code assignment. */
  orgCode?: string;
  /** The org size of the mercer assignment. */
  orgSize?: number;
  /** The country of the mercer job code assignment. */
  country?: string;
  /** The area of responsibility of the mercer job code assignment. */
  are?: string;
  /** The job code of the mercer job code assignment. */
  jobCode?: string;
  /** The valid from of the mercer job code assignment. */
  jobCodeValidFrom?: string;
  /** The valid to of the mercer job code assignment. */
  jobCodeValidTo?: string;
  /** The Mercer family name of the mercer job code assignment. */
  familyName?: string;
  /** The Mercer sub family name of the mercer job code assignment. */
  subFamilyName?: string;
  /** The Mercer specialization name of the mercer job code assignment. */
  specializationName?: string;
  /** The Mercer career stream of the mercer job code assignment. */
  careerStream?: string;
  /** The Mercer career level name of the mercer job code assignment. */
  careerLevelName?: string;
  /** The validation state of the mercer job code assignment. */
  jobCodeIsValidated?: boolean;
  /** The Mercer position class of the mercer job code assignment. */
  positionClass?: string;
  /** The valid from of the mercer position class assignment. */
  positionClassValidFrom?: string;
  /** The valid to of the mercer position class assignment. */
  positionClassValidTo?: string;
  /** The validation state of the mercer position class assignment. */
  positionClassIsValidated?: boolean;
  /** The Mercer internal level of the mercer job code assignment. */
  internalLevel?: string;
  page?: number;
  size?: number;
}

export interface EmployeesAdminServiceQueryFieldValuesMercerJobCodesRequestParams {
  /** The target property of the mercer job code field value. */
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The job code of the mercer job code. */
  jobCode?: string;
  /** The family of the mercer job code. */
  family?: string;
  /** The family of the mercer job code. */
  familyEq?: string;
  /** The family code of the mercer job code. */
  familyCode?: string;
  /** The sub family of the mercer job code. */
  subFamily?: string;
  /** The sub family of the mercer job code. */
  subFamilyEq?: string;
  /** The sub family code of the mercer job code. */
  subFamilyCode?: string;
  /** The specialization of the mercer job code. */
  specialization?: string;
  /** The specialization of the mercer job code. */
  specializationEq?: string;
  /** The specialization code of the mercer job code. */
  specializationCode?: string;
  /** The career stream of the mercer job code. */
  careerStream?: string;
  /** The career stream of the mercer job code. */
  careerStreamEq?: string;
  /** The career level of the mercer job code. */
  careerLevel?: string;
  /** The career level of the mercer job code. */
  careerLevelEq?: string;
  /** The career level short of the mercer job code. */
  careerLevelShort?: string;
  /** The career level short of the mercer job code. */
  careerLevelShortEq?: string;
  /** Flag if it should be a partial job code. */
  partialJobCode?: boolean;
  page?: number;
  size?: number;
}

export interface EmployeesAdminServiceQueryFieldValuesWithDescriptionMercerJobCodesRequestParams {
  /** The target property of the mercer job code field value. */
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  pageablePage?: number;
  pageableSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The job code of the mercer job code. */
  jobCode?: string;
  /** The family of the mercer job code. */
  family?: string;
  /** The family of the mercer job code. */
  familyEq?: string;
  /** The family code of the mercer job code. */
  familyCode?: string;
  /** The sub family of the mercer job code. */
  subFamily?: string;
  /** The sub family of the mercer job code. */
  subFamilyEq?: string;
  /** The sub family code of the mercer job code. */
  subFamilyCode?: string;
  /** The specialization of the mercer job code. */
  specialization?: string;
  /** The specialization of the mercer job code. */
  specializationEq?: string;
  /** The specialization code of the mercer job code. */
  specializationCode?: string;
  /** The career stream of the mercer job code. */
  careerStream?: string;
  /** The career stream of the mercer job code. */
  careerStreamEq?: string;
  /** The career level of the mercer job code. */
  careerLevel?: string;
  /** The career level of the mercer job code. */
  careerLevelEq?: string;
  /** The career level short of the mercer job code. */
  careerLevelShort?: string;
  /** The career level short of the mercer job code. */
  careerLevelShortEq?: string;
  /** Flag if it should be a partial job code. */
  partialJobCode?: boolean;
}

export interface EmployeesAdminServiceQueryJobProfileValuesMercerJobCodesRequestParams {
  /** The job code of the mercer job code. */
  jobCode?: string;
  /** The family of the mercer job code. */
  family?: string;
  /** The family of the mercer job code. */
  familyEq?: string;
  /** The family code of the mercer job code. */
  familyCode?: string;
  /** The sub family of the mercer job code. */
  subFamily?: string;
  /** The sub family of the mercer job code. */
  subFamilyEq?: string;
  /** The sub family code of the mercer job code. */
  subFamilyCode?: string;
  /** The specialization of the mercer job code. */
  specialization?: string;
  /** The specialization of the mercer job code. */
  specializationEq?: string;
  /** The specialization code of the mercer job code. */
  specializationCode?: string;
  /** The career stream of the mercer job code. */
  careerStream?: string;
  /** The career stream of the mercer job code. */
  careerStreamEq?: string;
  /** The career level of the mercer job code. */
  careerLevel?: string;
  /** The career level of the mercer job code. */
  careerLevelEq?: string;
  /** The career level short of the mercer job code. */
  careerLevelShort?: string;
  /** The career level short of the mercer job code. */
  careerLevelShortEq?: string;
  /** Flag if it should be a partial job code. */
  partialJobCode?: boolean;
}

export interface EmployeesAdminServiceQueryMercerJobCodeAssignmentsRequestParams {
  /** The gid of the mercer job assignment. */
  gid?: Array<string>;
  /** The last name of the mercer job assignment. */
  lastname?: string;
  /** The first name of the mercer job assignment. */
  firstname?: string;
  /** The org code of the mercer job assignment. */
  orgCodes?: Array<string>;
  /** The org size of the mercer job assignment. */
  orgSizes?: Array<number>;
  /** The country of the mercer job assignment. */
  countries?: Array<string>;
  /** The are of the mercer job assignment. */
  areCodes?: Array<string>;
  /** The job code of the mercer job assignment. */
  jobCodes?: Array<string>;
  /** The family of the mercer job assignment. */
  familyNames?: Array<string>;
  /** The sub family of the mercer job assignment. */
  subFamilyNames?: Array<string>;
  /** The specialization of the mercer job assignment. */
  specializationNames?: Array<string>;
  /** The career level of the mercer job assignment. */
  careerLevelNames?: Array<string>;
  /** The career stream of the mercer job assignment. */
  careerStreams?: Array<string>;
  /** The position class of the mercer job assignment. */
  positionClasses?: Array<number>;
  /** The internal level of the mercer job assignment. */
  internalLevels?: Array<string>;
  /** The job code valid from date of the mercer assignment. */
  jobCodeValidFrom?: string;
  /** The job code valid to date of the mercer assignment. */
  jobCodeValidTo?: string;
  /** The job code validated of the mercer assignment. */
  jobCodeIsValidated?: Array<boolean>;
  /** The position class valid from date of the mercer assignment. */
  positionClassValidFrom?: string;
  /** The position class valid to date of the mercer assignment. */
  positionClassValidTo?: string;
  /** The position class validated of the mercer assignment. */
  positionClassIsValidated?: Array<boolean>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface EmployeesAdminServiceQueryMercerJobCodesRequestParams {
  /** The job code of the mercer job code. */
  jobCode?: string;
  /** The family of the mercer job code. */
  family?: string;
  /** The family of the mercer job code. */
  familyEq?: string;
  /** The family code of the mercer job code. */
  familyCode?: string;
  /** The sub family of the mercer job code. */
  subFamily?: string;
  /** The sub family of the mercer job code. */
  subFamilyEq?: string;
  /** The sub family code of the mercer job code. */
  subFamilyCode?: string;
  /** The specialization of the mercer job code. */
  specialization?: string;
  /** The specialization of the mercer job code. */
  specializationEq?: string;
  /** The specialization code of the mercer job code. */
  specializationCode?: string;
  /** The career stream of the mercer job code. */
  careerStream?: string;
  /** The career stream of the mercer job code. */
  careerStreamEq?: string;
  /** The career level of the mercer job code. */
  careerLevel?: string;
  /** The career level of the mercer job code. */
  careerLevelEq?: string;
  /** The career level short of the mercer job code. */
  careerLevelShort?: string;
  /** The career level short of the mercer job code. */
  careerLevelShortEq?: string;
  /** Flag if it should be a partial job code. */
  partialJobCode?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface EmployeesAdminServiceSearchEmployeesEmployeesRequestParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  /** Query employees parameter. */
  employeesEmployeesQueryEmployeesWithExcludableGidsParameter?: EmployeesEmployeesQueryEmployeesWithExcludableGidsParameter;
}

export interface EmployeesAdminServiceSimulatePopulationBenchmarkSettingsRequestParams {
  id: string;
  page?: number;
  size?: number;
  /** The ruleset to use to simulate a population. */
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface EmployeesAdminServiceSimulatePopulationSecuritySettingsRequestParams {
  /** The unique id of the security settings to create a population simulation for. */
  id: string;
  page?: number;
  size?: number;
  /** The optional ruleset to create the population simulation with. */
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface EmployeesAdminServiceUnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeRequestParams {
  ruleId: string;
  employeeId: string;
}

export interface EmployeesAdminServiceUpdateAresRequestParams {
  /** The model to update an existing are with. */
  employeesAresUpdateAreModel?: EmployeesAresUpdateAreModel;
}

export interface EmployeesAdminServiceUpdateBenchmarkSettingsRequestParams {
  /** The unique id of the benchmark settings to update. */
  id: string;
  /** The model to update the benchmark settings with. */
  employeesBenchmarkSettingsUpdateBenchmarkSettingsModel?: EmployeesBenchmarkSettingsUpdateBenchmarkSettingsModel;
}

export interface EmployeesAdminServiceUpdateEmployeeInCompanyManagerRequestParams {
  /** The unique id of the employee to update the in company manager of. */
  employeeId: string;
  /** The model to update the in company manager with. */
  employeesEmployeeInCompanyManagerUpdateEmployeeInCompanyManagerModel?: EmployeesEmployeeInCompanyManagerUpdateEmployeeInCompanyManagerModel;
}

export interface EmployeesAdminServiceUpdateEmployeeInternalLevelRequestParams {
  /** The unique id of the employee to create or update the internal level of. */
  employeeId: string;
  /** The model data to create or update the employee\&#39;s internal level with. */
  siemensEnergyCOINClientApiRequestsEmployeesEmployeesUpdateEmployeeInternalLevelCommand?: SiemensEnergyCOINClientApiRequestsEmployeesEmployeesUpdateEmployeeInternalLevelCommand;
}

export interface EmployeesAdminServiceUpdateEmployeeLineManagerRequestParams {
  /** The unique id of the employee to update the line manager of. */
  employeeId: string;
  /** The model to update the line manager with. */
  employeesEmployeeLineManagerUpdateEmployeeLineManagerModel?: EmployeesEmployeeLineManagerUpdateEmployeeLineManagerModel;
}

export interface EmployeesAdminServiceUpdateInternalCommentsRequestParams {
  employeeId: string;
  /** The data to set the internal comment with. */
  employeesInternalCommentsUpdateInternalCommentModel?: EmployeesInternalCommentsUpdateInternalCommentModel;
}

export interface EmployeesAdminServiceUpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsRequestParams {
  /** The unique id of the employee to update the assignment of. */
  employeeId: string;
  /** The unique id of the assignment to update. */
  id: string;
  /** The model data to update the assignment with. */
  employeesMercerJobCodeAssignmentsUpdateMercerJobCodeAssignmentModel?: EmployeesMercerJobCodeAssignmentsUpdateMercerJobCodeAssignmentModel;
}

export interface EmployeesAdminServiceUpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsRequestParams {
  /** The unique id of the employee to update the assignment of. */
  employeeId: string;
  /** The unique id of the assignment to update. */
  id: string;
  /** The model data to update the assignment with. */
  employeesMercerJobCodeAssignmentsUpdateMercerPositionClassAssignmentModel?: EmployeesMercerJobCodeAssignmentsUpdateMercerPositionClassAssignmentModel;
}

export interface EmployeesAdminServiceUpdateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams {
  /** Command Model with metadata to update RuleBasedAccessFilter */
  siemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersUpdateRuleBasedAccessFilterCommand?: SiemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersUpdateRuleBasedAccessFilterCommand;
}

export interface EmployeesAdminServiceUpdateSecuritySettingsRequestParams {
  /** The unique id of the security settings to update. */
  id: string;
  /** The model data to update existing security settings with. */
  employeesSecuritySettingsUpdateSecuritySettingsModel?: EmployeesSecuritySettingsUpdateSecuritySettingsModel;
}

/**
 * @deprecated The v1 API client is deprecated. Use the v2 client from `@coin/shared/core/data-access-v2` instead.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeesAdminService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Assigns benchmarks to employees.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignEmployeeBenchmarks(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfBenchmarkAssignmentMetadata>;
  public assignEmployeeBenchmarks(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfBenchmarkAssignmentMetadata>>;
  public assignEmployeeBenchmarks(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfBenchmarkAssignmentMetadata>>;
  public assignEmployeeBenchmarks(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/benchmarks`;
    return this.httpClient.request<TransactionStatusOfBenchmarkAssignmentMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Assign RuleBasedAccessFilter to Employee
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: EmployeesAdminServiceAssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: EmployeesAdminServiceAssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: EmployeesAdminServiceAssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: EmployeesAdminServiceAssignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployeeRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const ruleId = requestParameters?.ruleId;
    if (ruleId === null || ruleId === undefined) {
      throw new Error(
        'Required parameter ruleId was null or undefined when calling assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee.'
      );
    }
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling assignRuleBasedAccessFilterToEmployeeRuleBasedAccessFilterEmployee.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/rule-based-access-filters/${this.configuration.encodeParam({ name: 'ruleId', value: ruleId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Changes specified benchmark settings priorities.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceChangePrioritiesBenchmarkSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public changePrioritiesBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceChangePrioritiesBenchmarkSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public changePrioritiesBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceChangePrioritiesBenchmarkSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public changePrioritiesBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceChangePrioritiesBenchmarkSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const seasonsPrioritiesChangeManyPrioritiesModel = requestParameters?.seasonsPrioritiesChangeManyPrioritiesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/benchmarks/settings/priorities`;
    return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsPrioritiesChangeManyPrioritiesModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates a new are.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createAres(
    requestParameters?: EmployeesAdminServiceCreateAresRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesAresAreModel>;
  public createAres(
    requestParameters?: EmployeesAdminServiceCreateAresRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesAresAreModel>>;
  public createAres(
    requestParameters?: EmployeesAdminServiceCreateAresRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesAresAreModel>>;
  public createAres(
    requestParameters?: EmployeesAdminServiceCreateAresRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeesAresCreateAreModel = requestParameters?.employeesAresCreateAreModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/ares`;
    return this.httpClient.request<EmployeesAresAreModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: employeesAresCreateAreModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates a new benchmark settings.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceCreateBenchmarkSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesBenchmarkSettingsBenchmarkSettingsModel>;
  public createBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceCreateBenchmarkSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesBenchmarkSettingsBenchmarkSettingsModel>>;
  public createBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceCreateBenchmarkSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesBenchmarkSettingsBenchmarkSettingsModel>>;
  public createBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceCreateBenchmarkSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeesBenchmarkSettingsCreateBenchmarkSettingsModel =
      requestParameters?.employeesBenchmarkSettingsCreateBenchmarkSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/benchmarks/settings`;
    return this.httpClient.request<EmployeesBenchmarkSettingsBenchmarkSettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesBenchmarkSettingsCreateBenchmarkSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a job code and position class assignment for an employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceCreateMercerJobCodeAssignmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentModel>;
  public createMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceCreateMercerJobCodeAssignmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentModel>>;
  public createMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceCreateMercerJobCodeAssignmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentModel>>;
  public createMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceCreateMercerJobCodeAssignmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeesMercerJobCodeAssignmentsCreateMercerJobCodeAndPositionClassAssignmentModel =
      requestParameters?.employeesMercerJobCodeAssignmentsCreateMercerJobCodeAndPositionClassAssignmentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/employees`;
    return this.httpClient.request<EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesMercerJobCodeAssignmentsCreateMercerJobCodeAndPositionClassAssignmentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates RuleBasedAccessFilter
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceCreateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>;
  public createRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceCreateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>>;
  public createRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceCreateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>>;
  public createRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceCreateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const siemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersCreateRuleBasedAccessFilterCommand =
      requestParameters?.siemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersCreateRuleBasedAccessFilterCommand;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/rule-based-access-filters`;
    return this.httpClient.request<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: siemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersCreateRuleBasedAccessFilterCommand,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates new security settings.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSecuritySettings(
    requestParameters?: EmployeesAdminServiceCreateSecuritySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesSecuritySettingsSecuritySettingsModel>;
  public createSecuritySettings(
    requestParameters?: EmployeesAdminServiceCreateSecuritySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesSecuritySettingsSecuritySettingsModel>>;
  public createSecuritySettings(
    requestParameters?: EmployeesAdminServiceCreateSecuritySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesSecuritySettingsSecuritySettingsModel>>;
  public createSecuritySettings(
    requestParameters?: EmployeesAdminServiceCreateSecuritySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeesSecuritySettingsCreateSecuritySettingsModel =
      requestParameters?.employeesSecuritySettingsCreateSecuritySettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/security-settings`;
    return this.httpClient.request<EmployeesSecuritySettingsSecuritySettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesSecuritySettingsCreateSecuritySettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Deletes an existing are.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteAres(
    requestParameters?: EmployeesAdminServiceDeleteAresRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteAres(
    requestParameters?: EmployeesAdminServiceDeleteAresRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteAres(
    requestParameters?: EmployeesAdminServiceDeleteAresRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteAres(
    requestParameters?: EmployeesAdminServiceDeleteAresRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteAres.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/ares/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Deletes RuleBasedAccessFilter
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceDeleteRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public deleteRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceDeleteRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceDeleteRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public deleteRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceDeleteRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const ruleId = requestParameters?.ruleId;
    if (ruleId === null || ruleId === undefined) {
      throw new Error(
        'Required parameter ruleId was null or undefined when calling deleteRuleBasedAccessFilterRuleBasedAccessFilter.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/rule-based-access-filters/${this.configuration.encodeParam({ name: 'ruleId', value: ruleId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Deletes existing security settings by their unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSecuritySettings(
    requestParameters?: EmployeesAdminServiceDeleteSecuritySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteSecuritySettings(
    requestParameters?: EmployeesAdminServiceDeleteSecuritySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteSecuritySettings(
    requestParameters?: EmployeesAdminServiceDeleteSecuritySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteSecuritySettings(
    requestParameters?: EmployeesAdminServiceDeleteSecuritySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteSecuritySettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/security-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Exports all advanced benchmarks.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeeBenchmarkAdvanced(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeeBenchmarkAdvanced(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeBenchmarkAdvanced(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeBenchmarkAdvanced(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/benchmarks-advanced/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Exports all benchmarks.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeeBenchmarks(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeeBenchmarks(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeBenchmarks(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeBenchmarks(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/benchmarks/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeesExpertsDataEmployeesExperts(
    requestParameters?: EmployeesAdminServiceExportEmployeesExpertsDataEmployeesExpertsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeesExpertsDataEmployeesExperts(
    requestParameters?: EmployeesAdminServiceExportEmployeesExpertsDataEmployeesExpertsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeesExpertsDataEmployeesExperts(
    requestParameters?: EmployeesAdminServiceExportEmployeesExpertsDataEmployeesExpertsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeesExpertsDataEmployeesExperts(
    requestParameters?: EmployeesAdminServiceExportEmployeesExpertsDataEmployeesExpertsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const fileName = requestParameters?.fileName;
    const transactionId = requestParameters?.transactionId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (fileName !== undefined && fileName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fileName, 'fileName');
    }
    if (transactionId !== undefined && transactionId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>transactionId, 'transactionId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/experts/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Export MJA data to DataHub
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportJobAssignmentsDatahub(
    requestParameters?: EmployeesAdminServiceExportJobAssignmentsDatahubRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public exportJobAssignmentsDatahub(
    requestParameters?: EmployeesAdminServiceExportJobAssignmentsDatahubRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public exportJobAssignmentsDatahub(
    requestParameters?: EmployeesAdminServiceExportJobAssignmentsDatahubRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public exportJobAssignmentsDatahub(
    requestParameters?: EmployeesAdminServiceExportJobAssignmentsDatahubRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const exportS3 = requestParameters?.exportS3;
    const exportDataHub = requestParameters?.exportDataHub;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (exportS3 !== undefined && exportS3 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>exportS3, 'exportS3');
    }
    if (exportDataHub !== undefined && exportDataHub !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>exportDataHub, 'exportDataHub');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/employees/mercer-export/job-assignments`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Export MJC data to DataHub
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportJobCodesDatahub(
    requestParameters?: EmployeesAdminServiceExportJobCodesDatahubRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public exportJobCodesDatahub(
    requestParameters?: EmployeesAdminServiceExportJobCodesDatahubRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public exportJobCodesDatahub(
    requestParameters?: EmployeesAdminServiceExportJobCodesDatahubRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public exportJobCodesDatahub(
    requestParameters?: EmployeesAdminServiceExportJobCodesDatahubRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const exportS3 = requestParameters?.exportS3;
    const exportDataHub = requestParameters?.exportDataHub;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (exportS3 !== undefined && exportS3 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>exportS3, 'exportS3');
    }
    if (exportDataHub !== undefined && exportDataHub !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>exportDataHub, 'exportDataHub');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/employees/mercer-export/job-codes`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets an existing are by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAres(
    requestParameters?: EmployeesAdminServiceGetAresRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesAresAreModel>;
  public getAres(
    requestParameters?: EmployeesAdminServiceGetAresRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesAresAreModel>>;
  public getAres(
    requestParameters?: EmployeesAdminServiceGetAresRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesAresAreModel>>;
  public getAres(
    requestParameters?: EmployeesAdminServiceGetAresRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getAres.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/ares/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesAresAreModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets an employee by its unique gid.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByGidEmployees(
    requestParameters?: EmployeesAdminServiceGetByGidEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesEmployeesFullEmployeeModel>;
  public getByGidEmployees(
    requestParameters?: EmployeesAdminServiceGetByGidEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesEmployeesFullEmployeeModel>>;
  public getByGidEmployees(
    requestParameters?: EmployeesAdminServiceGetByGidEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesEmployeesFullEmployeeModel>>;
  public getByGidEmployees(
    requestParameters?: EmployeesAdminServiceGetByGidEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;
    if (gid === null || gid === undefined) {
      throw new Error('Required parameter gid was null or undefined when calling getByGidEmployees.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/gid/${this.configuration.encodeParam({ name: 'gid', value: gid, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<EmployeesEmployeesFullEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets an existing colorado by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getColorados(
    requestParameters?: EmployeesAdminServiceGetColoradosRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesColoradosColoradoModel>;
  public getColorados(
    requestParameters?: EmployeesAdminServiceGetColoradosRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesColoradosColoradoModel>>;
  public getColorados(
    requestParameters?: EmployeesAdminServiceGetColoradosRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesColoradosColoradoModel>>;
  public getColorados(
    requestParameters?: EmployeesAdminServiceGetColoradosRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getColorados.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/colorados/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesColoradosColoradoModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets the count of employees by using provided rule set.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCountEmployees(
    requestParameters?: EmployeesAdminServiceGetCountEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<number>;
  public getCountEmployees(
    requestParameters?: EmployeesAdminServiceGetCountEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<number>>;
  public getCountEmployees(
    requestParameters?: EmployeesAdminServiceGetCountEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<number>>;
  public getCountEmployees(
    requestParameters?: EmployeesAdminServiceGetCountEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/count`;
    return this.httpClient.request<number>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: sharedRuleEngineRuleSetModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets the internal level of an existing employee.
   * will be displayed in details view of mercerJobCode assignments
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeInternalLevel(
    requestParameters?: EmployeesAdminServiceGetEmployeeInternalLevelRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesEmployeesEmployeeInternalLevelModel>;
  public getEmployeeInternalLevel(
    requestParameters?: EmployeesAdminServiceGetEmployeeInternalLevelRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesEmployeesEmployeeInternalLevelModel>>;
  public getEmployeeInternalLevel(
    requestParameters?: EmployeesAdminServiceGetEmployeeInternalLevelRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesEmployeesEmployeeInternalLevelModel>>;
  public getEmployeeInternalLevel(
    requestParameters?: EmployeesAdminServiceGetEmployeeInternalLevelRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling getEmployeeInternalLevel.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/internal-level`;
    return this.httpClient.request<EmployeesEmployeesEmployeeInternalLevelModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets an existing -available to reorg app- employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeRowLevelSecurity(
    requestParameters?: EmployeesAdminServiceGetEmployeeRowLevelSecurityRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesEmployeesFullEmployeeForReorgAppModel>;
  public getEmployeeRowLevelSecurity(
    requestParameters?: EmployeesAdminServiceGetEmployeeRowLevelSecurityRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesEmployeesFullEmployeeForReorgAppModel>>;
  public getEmployeeRowLevelSecurity(
    requestParameters?: EmployeesAdminServiceGetEmployeeRowLevelSecurityRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesEmployeesFullEmployeeForReorgAppModel>>;
  public getEmployeeRowLevelSecurity(
    requestParameters?: EmployeesAdminServiceGetEmployeeRowLevelSecurityRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getEmployeeRowLevelSecurity.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/row-level-security/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesEmployeesFullEmployeeForReorgAppModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets an existing employee with compensation data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeWithCompensations(
    requestParameters?: EmployeesAdminServiceGetEmployeeWithCompensationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesEmployeesFullEmployeeModel>;
  public getEmployeeWithCompensations(
    requestParameters?: EmployeesAdminServiceGetEmployeeWithCompensationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesEmployeesFullEmployeeModel>>;
  public getEmployeeWithCompensations(
    requestParameters?: EmployeesAdminServiceGetEmployeeWithCompensationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesEmployeesFullEmployeeModel>>;
  public getEmployeeWithCompensations(
    requestParameters?: EmployeesAdminServiceGetEmployeeWithCompensationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getEmployeeWithCompensations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/compensation`;
    return this.httpClient.request<EmployeesEmployeesFullEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets an employee by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployees(
    requestParameters?: EmployeesAdminServiceGetEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesEmployeesEmployeeModel>;
  public getEmployees(
    requestParameters?: EmployeesAdminServiceGetEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesEmployeesEmployeeModel>>;
  public getEmployees(
    requestParameters?: EmployeesAdminServiceGetEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesEmployeesEmployeeModel>>;
  public getEmployees(
    requestParameters?: EmployeesAdminServiceGetEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getEmployees.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesEmployeesEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets the internal comment of an existing employee by its unique id.
   * Frontend displays this information in details view of mercer job code assignments.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInternalComments(
    requestParameters?: EmployeesAdminServiceGetInternalCommentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesInternalCommentsInternalCommentModel>;
  public getInternalComments(
    requestParameters?: EmployeesAdminServiceGetInternalCommentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesInternalCommentsInternalCommentModel>>;
  public getInternalComments(
    requestParameters?: EmployeesAdminServiceGetInternalCommentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesInternalCommentsInternalCommentModel>>;
  public getInternalComments(
    requestParameters?: EmployeesAdminServiceGetInternalCommentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling getInternalComments.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/internal-comment`;
    return this.httpClient.request<EmployeesInternalCommentsInternalCommentModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets an existing mercer job code by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMercerJobCodes(
    requestParameters?: EmployeesAdminServiceGetMercerJobCodesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerJobCodesMercerJobCodeModel>;
  public getMercerJobCodes(
    requestParameters?: EmployeesAdminServiceGetMercerJobCodesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerJobCodesMercerJobCodeModel>>;
  public getMercerJobCodes(
    requestParameters?: EmployeesAdminServiceGetMercerJobCodesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerJobCodesMercerJobCodeModel>>;
  public getMercerJobCodes(
    requestParameters?: EmployeesAdminServiceGetMercerJobCodesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getMercerJobCodes.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesMercerJobCodesMercerJobCodeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get all RuleBasedAccessFilters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRuleBasedAccessFiltersRuleBasedAccessFilter(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>>;
  public getRuleBasedAccessFiltersRuleBasedAccessFilter(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>>>;
  public getRuleBasedAccessFiltersRuleBasedAccessFilter(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>>>;
  public getRuleBasedAccessFiltersRuleBasedAccessFilter(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/rule-based-access-filters`;
    return this.httpClient.request<Array<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets the ares search scope.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeAres(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedEntitySearchScopeModel>;
  public getScopeAres(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedEntitySearchScopeModel>>;
  public getScopeAres(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedEntitySearchScopeModel>>;
  public getScopeAres(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/ares/scope`;
    return this.httpClient.request<SharedEntitySearchScopeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets the employees search scope.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getScopeEmployees(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedEntitySearchScopeModel>;
  public getScopeEmployees(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedEntitySearchScopeModel>>;
  public getScopeEmployees(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedEntitySearchScopeModel>>;
  public getScopeEmployees(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/scope`;
    return this.httpClient.request<SharedEntitySearchScopeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets the existing security settings by their unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSecuritySettings(
    requestParameters?: EmployeesAdminServiceGetSecuritySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesSecuritySettingsSecuritySettingsModel>;
  public getSecuritySettings(
    requestParameters?: EmployeesAdminServiceGetSecuritySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesSecuritySettingsSecuritySettingsModel>>;
  public getSecuritySettings(
    requestParameters?: EmployeesAdminServiceGetSecuritySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesSecuritySettingsSecuritySettingsModel>>;
  public getSecuritySettings(
    requestParameters?: EmployeesAdminServiceGetSecuritySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getSecuritySettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/security-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesSecuritySettingsSecuritySettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Exports all assignments.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postAssignmentsExportMercerJobCodeAssignmentsExport(
    requestParameters?: EmployeesAdminServicePostAssignmentsExportMercerJobCodeAssignmentsExportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public postAssignmentsExportMercerJobCodeAssignmentsExport(
    requestParameters?: EmployeesAdminServicePostAssignmentsExportMercerJobCodeAssignmentsExportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public postAssignmentsExportMercerJobCodeAssignmentsExport(
    requestParameters?: EmployeesAdminServicePostAssignmentsExportMercerJobCodeAssignmentsExportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public postAssignmentsExportMercerJobCodeAssignmentsExport(
    requestParameters?: EmployeesAdminServicePostAssignmentsExportMercerJobCodeAssignmentsExportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;
    const lastname = requestParameters?.lastname;
    const firstname = requestParameters?.firstname;
    const orgCodes = requestParameters?.orgCodes;
    const orgSizes = requestParameters?.orgSizes;
    const countries = requestParameters?.countries;
    const areCodes = requestParameters?.areCodes;
    const jobCodes = requestParameters?.jobCodes;
    const familyNames = requestParameters?.familyNames;
    const subFamilyNames = requestParameters?.subFamilyNames;
    const specializationNames = requestParameters?.specializationNames;
    const careerLevelNames = requestParameters?.careerLevelNames;
    const careerStreams = requestParameters?.careerStreams;
    const positionClasses = requestParameters?.positionClasses;
    const internalLevels = requestParameters?.internalLevels;
    const jobCodeValidFrom = requestParameters?.jobCodeValidFrom;
    const jobCodeValidTo = requestParameters?.jobCodeValidTo;
    const jobCodeIsValidated = requestParameters?.jobCodeIsValidated;
    const positionClassValidFrom = requestParameters?.positionClassValidFrom;
    const positionClassValidTo = requestParameters?.positionClassValidTo;
    const positionClassIsValidated = requestParameters?.positionClassIsValidated;
    const employeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModel =
      requestParameters?.employeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (orgCodes) {
      orgCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodes');
      });
    }
    if (orgSizes) {
      orgSizes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSizes');
      });
    }
    if (countries) {
      countries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Countries');
      });
    }
    if (areCodes) {
      areCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCodes');
      });
    }
    if (jobCodes) {
      jobCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'JobCodes');
      });
    }
    if (familyNames) {
      familyNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'FamilyNames');
      });
    }
    if (subFamilyNames) {
      subFamilyNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SubFamilyNames');
      });
    }
    if (specializationNames) {
      specializationNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SpecializationNames');
      });
    }
    if (careerLevelNames) {
      careerLevelNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CareerLevelNames');
      });
    }
    if (careerStreams) {
      careerStreams.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CareerStreams');
      });
    }
    if (positionClasses) {
      positionClasses.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClasses');
      });
    }
    if (internalLevels) {
      internalLevels.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'InternalLevels');
      });
    }
    if (jobCodeValidFrom !== undefined && jobCodeValidFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>jobCodeValidFrom,
        'JobCodeValidFrom'
      );
    }
    if (jobCodeValidTo !== undefined && jobCodeValidTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCodeValidTo, 'JobCodeValidTo');
    }
    if (jobCodeIsValidated) {
      jobCodeIsValidated.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'JobCodeIsValidated');
      });
    }
    if (positionClassValidFrom !== undefined && positionClassValidFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionClassValidFrom,
        'PositionClassValidFrom'
      );
    }
    if (positionClassValidTo !== undefined && positionClassValidTo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionClassValidTo,
        'PositionClassValidTo'
      );
    }
    if (positionClassIsValidated) {
      positionClassIsValidated.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'PositionClassIsValidated'
        );
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/assignments-export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postMercerStandingNotificationMercerStandingNotification(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public postMercerStandingNotificationMercerStandingNotification(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public postMercerStandingNotificationMercerStandingNotification(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public postMercerStandingNotificationMercerStandingNotification(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/mercer-standing-notification`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postMissingOrganisationInformationNotificationMissingOrganisationInformationNotification(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public postMissingOrganisationInformationNotificationMissingOrganisationInformationNotification(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public postMissingOrganisationInformationNotificationMissingOrganisationInformationNotification(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public postMissingOrganisationInformationNotificationMissingOrganisationInformationNotification(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/missing-organisation-information-notification`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing ares by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAres(
    requestParameters?: EmployeesAdminServiceQueryAresRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesAresAreModel>;
  public queryAres(
    requestParameters?: EmployeesAdminServiceQueryAresRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesAresAreModel>>;
  public queryAres(
    requestParameters?: EmployeesAdminServiceQueryAresRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesAresAreModel>>;
  public queryAres(
    requestParameters?: EmployeesAdminServiceQueryAresRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const searchQuery = requestParameters?.searchQuery;
    const countryCode = requestParameters?.countryCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (searchQuery !== undefined && searchQuery !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchQuery, 'SearchQuery');
    }
    if (countryCode !== undefined && countryCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>countryCode, 'CountryCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/ares`;
    return this.httpClient.request<SharedPageModelOfEmployeesAresAreModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing benchmark settings by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceQueryBenchmarkSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesBenchmarkSettingsBenchmarkSettingsModel>;
  public queryBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceQueryBenchmarkSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesBenchmarkSettingsBenchmarkSettingsModel>>;
  public queryBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceQueryBenchmarkSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesBenchmarkSettingsBenchmarkSettingsModel>>;
  public queryBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceQueryBenchmarkSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/benchmarks/settings`;
    return this.httpClient.request<SharedPageModelOfEmployeesBenchmarkSettingsBenchmarkSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets the assigned JobCodes and PositionClasses for an employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryByEmployeeMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryByEmployeeMercerJobCodeAssignmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentLightModel>;
  public queryByEmployeeMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryByEmployeeMercerJobCodeAssignmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentLightModel>>;
  public queryByEmployeeMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryByEmployeeMercerJobCodeAssignmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentLightModel>>;
  public queryByEmployeeMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryByEmployeeMercerJobCodeAssignmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;
    if (gid === null || gid === undefined) {
      throw new Error(
        'Required parameter gid was null or undefined when calling queryByEmployeeMercerJobCodeAssignments.'
      );
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/employees`;
    return this.httpClient.request<EmployeesMercerJobCodeAssignmentsMercerJobCodeAndPositionClassAssignmentLightModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing employees.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBySearchEmployees(
    requestParameters?: EmployeesAdminServiceQueryBySearchEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesFullEmployeeModel>;
  public queryBySearchEmployees(
    requestParameters?: EmployeesAdminServiceQueryBySearchEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesFullEmployeeModel>>;
  public queryBySearchEmployees(
    requestParameters?: EmployeesAdminServiceQueryBySearchEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesFullEmployeeModel>>;
  public queryBySearchEmployees(
    requestParameters?: EmployeesAdminServiceQueryBySearchEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const search = requestParameters?.search;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/query`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesFullEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all directs of an in company manager.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDirectsInCompanyManagers(
    requestParameters?: EmployeesAdminServiceQueryDirectsInCompanyManagersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeDirectModel>;
  public queryDirectsInCompanyManagers(
    requestParameters?: EmployeesAdminServiceQueryDirectsInCompanyManagersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeDirectModel>>;
  public queryDirectsInCompanyManagers(
    requestParameters?: EmployeesAdminServiceQueryDirectsInCompanyManagersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeDirectModel>>;
  public queryDirectsInCompanyManagers(
    requestParameters?: EmployeesAdminServiceQueryDirectsInCompanyManagersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    const gid = requestParameters?.gid;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (id !== undefined && id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>id, 'Id');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/in-company-managers/directs`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeDirectModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all directs of a line manager.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDirectsLineManagers(
    requestParameters?: EmployeesAdminServiceQueryDirectsLineManagersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeDirectModel>;
  public queryDirectsLineManagers(
    requestParameters?: EmployeesAdminServiceQueryDirectsLineManagersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeDirectModel>>;
  public queryDirectsLineManagers(
    requestParameters?: EmployeesAdminServiceQueryDirectsLineManagersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeDirectModel>>;
  public queryDirectsLineManagers(
    requestParameters?: EmployeesAdminServiceQueryDirectsLineManagersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    const gid = requestParameters?.gid;
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (id !== undefined && id !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>id, 'Id');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/line-managers/directs`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeDirectModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all available employees for reorg app.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeRowLevelSecurity(
    requestParameters?: EmployeesAdminServiceQueryEmployeeRowLevelSecurityRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesFullEmployeeForReorgAppModel>;
  public queryEmployeeRowLevelSecurity(
    requestParameters?: EmployeesAdminServiceQueryEmployeeRowLevelSecurityRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesFullEmployeeForReorgAppModel>>;
  public queryEmployeeRowLevelSecurity(
    requestParameters?: EmployeesAdminServiceQueryEmployeeRowLevelSecurityRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesFullEmployeeForReorgAppModel>>;
  public queryEmployeeRowLevelSecurity(
    requestParameters?: EmployeesAdminServiceQueryEmployeeRowLevelSecurityRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;
    const name = requestParameters?.name;
    const orgCode = requestParameters?.orgCode;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/row-level-security`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesFullEmployeeForReorgAppModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing employees.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployees(
    requestParameters?: EmployeesAdminServiceQueryEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeModel>;
  public queryEmployees(
    requestParameters?: EmployeesAdminServiceQueryEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public queryEmployees(
    requestParameters?: EmployeesAdminServiceQueryEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public queryEmployees(
    requestParameters?: EmployeesAdminServiceQueryEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;
    const name = requestParameters?.name;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const placeOfAction = requestParameters?.placeOfAction;
    const orgCode = requestParameters?.orgCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (name !== undefined && name !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>name, 'Name');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (placeOfAction) {
      placeOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlaceOfAction');
      });
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing employees by provided rule set.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeesEmployees(
    requestParameters?: EmployeesAdminServiceQueryEmployeesEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeModel>;
  public queryEmployeesEmployees(
    requestParameters?: EmployeesAdminServiceQueryEmployeesEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public queryEmployeesEmployees(
    requestParameters?: EmployeesAdminServiceQueryEmployeesEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public queryEmployeesEmployees(
    requestParameters?: EmployeesAdminServiceQueryEmployeesEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeesEmployeesQueryEmployeesByRuleSetParameter =
      requestParameters?.employeesEmployeesQueryEmployeesByRuleSetParameter;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesEmployeesQueryEmployeesByRuleSetParameter,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all fieldvalues for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesEmployees(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<string>>;
  public queryFieldValuesEmployees(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<string>>>;
  public queryFieldValuesEmployees(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<string>>>;
  public queryFieldValuesEmployees(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const fieldname = requestParameters?.fieldname;
    if (fieldname === null || fieldname === undefined) {
      throw new Error('Required parameter fieldname was null or undefined when calling queryFieldValuesEmployees.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/field-values/${this.configuration.encodeParam({ name: 'fieldname', value: fieldname, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<string>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets all fieldvalues for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesMercerJobCodeAssignmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesMercerJobCodeAssignmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesMercerJobCodeAssignmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesMercerJobCodeAssignmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error(
        'Required parameter targetProperty was null or undefined when calling queryFieldValuesMercerJobCodeAssignments.'
      );
    }
    const orgCode = requestParameters?.orgCode;
    const orgSize = requestParameters?.orgSize;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const jobCode = requestParameters?.jobCode;
    const jobCodeValidFrom = requestParameters?.jobCodeValidFrom;
    const jobCodeValidTo = requestParameters?.jobCodeValidTo;
    const familyName = requestParameters?.familyName;
    const subFamilyName = requestParameters?.subFamilyName;
    const specializationName = requestParameters?.specializationName;
    const careerStream = requestParameters?.careerStream;
    const careerLevelName = requestParameters?.careerLevelName;
    const jobCodeIsValidated = requestParameters?.jobCodeIsValidated;
    const positionClass = requestParameters?.positionClass;
    const positionClassValidFrom = requestParameters?.positionClassValidFrom;
    const positionClassValidTo = requestParameters?.positionClassValidTo;
    const positionClassIsValidated = requestParameters?.positionClassIsValidated;
    const internalLevel = requestParameters?.internalLevel;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (orgSize !== undefined && orgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgSize, 'OrgSize');
    }
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (are !== undefined && are !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>are, 'Are');
    }
    if (jobCode !== undefined && jobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCode, 'JobCode');
    }
    if (jobCodeValidFrom !== undefined && jobCodeValidFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>jobCodeValidFrom,
        'JobCodeValidFrom'
      );
    }
    if (jobCodeValidTo !== undefined && jobCodeValidTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCodeValidTo, 'JobCodeValidTo');
    }
    if (familyName !== undefined && familyName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyName, 'FamilyName');
    }
    if (subFamilyName !== undefined && subFamilyName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyName, 'SubFamilyName');
    }
    if (specializationName !== undefined && specializationName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationName,
        'SpecializationName'
      );
    }
    if (careerStream !== undefined && careerStream !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStream, 'CareerStream');
    }
    if (careerLevelName !== undefined && careerLevelName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevelName, 'CareerLevelName');
    }
    if (jobCodeIsValidated !== undefined && jobCodeIsValidated !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>jobCodeIsValidated,
        'JobCodeIsValidated'
      );
    }
    if (positionClass !== undefined && positionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionClass, 'PositionClass');
    }
    if (positionClassValidFrom !== undefined && positionClassValidFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionClassValidFrom,
        'PositionClassValidFrom'
      );
    }
    if (positionClassValidTo !== undefined && positionClassValidTo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionClassValidTo,
        'PositionClassValidTo'
      );
    }
    if (positionClassIsValidated !== undefined && positionClassIsValidated !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionClassIsValidated,
        'PositionClassIsValidated'
      );
    }
    if (internalLevel !== undefined && internalLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>internalLevel, 'InternalLevel');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/assignments/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all field values for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesMercerJobCodesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesMercerJobCodesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesMercerJobCodesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesMercerJobCodesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error(
        'Required parameter targetProperty was null or undefined when calling queryFieldValuesMercerJobCodes.'
      );
    }
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const jobCode = requestParameters?.jobCode;
    const family = requestParameters?.family;
    const familyEq = requestParameters?.familyEq;
    const familyCode = requestParameters?.familyCode;
    const subFamily = requestParameters?.subFamily;
    const subFamilyEq = requestParameters?.subFamilyEq;
    const subFamilyCode = requestParameters?.subFamilyCode;
    const specialization = requestParameters?.specialization;
    const specializationEq = requestParameters?.specializationEq;
    const specializationCode = requestParameters?.specializationCode;
    const careerStream = requestParameters?.careerStream;
    const careerStreamEq = requestParameters?.careerStreamEq;
    const careerLevel = requestParameters?.careerLevel;
    const careerLevelEq = requestParameters?.careerLevelEq;
    const careerLevelShort = requestParameters?.careerLevelShort;
    const careerLevelShortEq = requestParameters?.careerLevelShortEq;
    const partialJobCode = requestParameters?.partialJobCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (jobCode !== undefined && jobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCode, 'JobCode');
    }
    if (family !== undefined && family !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>family, 'Family');
    }
    if (familyEq !== undefined && familyEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyEq, 'FamilyEq');
    }
    if (familyCode !== undefined && familyCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyCode, 'FamilyCode');
    }
    if (subFamily !== undefined && subFamily !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamily, 'SubFamily');
    }
    if (subFamilyEq !== undefined && subFamilyEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyEq, 'SubFamilyEq');
    }
    if (subFamilyCode !== undefined && subFamilyCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyCode, 'SubFamilyCode');
    }
    if (specialization !== undefined && specialization !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>specialization, 'Specialization');
    }
    if (specializationEq !== undefined && specializationEq !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationEq,
        'SpecializationEq'
      );
    }
    if (specializationCode !== undefined && specializationCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationCode,
        'SpecializationCode'
      );
    }
    if (careerStream !== undefined && careerStream !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStream, 'CareerStream');
    }
    if (careerStreamEq !== undefined && careerStreamEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStreamEq, 'CareerStreamEq');
    }
    if (careerLevel !== undefined && careerLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevel, 'CareerLevel');
    }
    if (careerLevelEq !== undefined && careerLevelEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevelEq, 'CareerLevelEq');
    }
    if (careerLevelShort !== undefined && careerLevelShort !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>careerLevelShort,
        'CareerLevelShort'
      );
    }
    if (careerLevelShortEq !== undefined && careerLevelShortEq !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>careerLevelShortEq,
        'CareerLevelShortEq'
      );
    }
    if (partialJobCode !== undefined && partialJobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>partialJobCode, 'PartialJobCode');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all field values with descriptions for a specific field.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesWithDescriptionMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesWithDescriptionMercerJobCodesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSharedFieldValueWithDescriptionModel>;
  public queryFieldValuesWithDescriptionMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesWithDescriptionMercerJobCodesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSharedFieldValueWithDescriptionModel>>;
  public queryFieldValuesWithDescriptionMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesWithDescriptionMercerJobCodesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSharedFieldValueWithDescriptionModel>>;
  public queryFieldValuesWithDescriptionMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryFieldValuesWithDescriptionMercerJobCodesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error(
        'Required parameter targetProperty was null or undefined when calling queryFieldValuesWithDescriptionMercerJobCodes.'
      );
    }
    const pageablePage = requestParameters?.pageablePage;
    const pageableSize = requestParameters?.pageableSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const jobCode = requestParameters?.jobCode;
    const family = requestParameters?.family;
    const familyEq = requestParameters?.familyEq;
    const familyCode = requestParameters?.familyCode;
    const subFamily = requestParameters?.subFamily;
    const subFamilyEq = requestParameters?.subFamilyEq;
    const subFamilyCode = requestParameters?.subFamilyCode;
    const specialization = requestParameters?.specialization;
    const specializationEq = requestParameters?.specializationEq;
    const specializationCode = requestParameters?.specializationCode;
    const careerStream = requestParameters?.careerStream;
    const careerStreamEq = requestParameters?.careerStreamEq;
    const careerLevel = requestParameters?.careerLevel;
    const careerLevelEq = requestParameters?.careerLevelEq;
    const careerLevelShort = requestParameters?.careerLevelShort;
    const careerLevelShortEq = requestParameters?.careerLevelShortEq;
    const partialJobCode = requestParameters?.partialJobCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (pageablePage !== undefined && pageablePage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageablePage, 'Pageable.Page');
    }
    if (pageableSize !== undefined && pageableSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pageableSize, 'Pageable.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (jobCode !== undefined && jobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCode, 'JobCode');
    }
    if (family !== undefined && family !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>family, 'Family');
    }
    if (familyEq !== undefined && familyEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyEq, 'FamilyEq');
    }
    if (familyCode !== undefined && familyCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyCode, 'FamilyCode');
    }
    if (subFamily !== undefined && subFamily !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamily, 'SubFamily');
    }
    if (subFamilyEq !== undefined && subFamilyEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyEq, 'SubFamilyEq');
    }
    if (subFamilyCode !== undefined && subFamilyCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyCode, 'SubFamilyCode');
    }
    if (specialization !== undefined && specialization !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>specialization, 'Specialization');
    }
    if (specializationEq !== undefined && specializationEq !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationEq,
        'SpecializationEq'
      );
    }
    if (specializationCode !== undefined && specializationCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationCode,
        'SpecializationCode'
      );
    }
    if (careerStream !== undefined && careerStream !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStream, 'CareerStream');
    }
    if (careerStreamEq !== undefined && careerStreamEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStreamEq, 'CareerStreamEq');
    }
    if (careerLevel !== undefined && careerLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevel, 'CareerLevel');
    }
    if (careerLevelEq !== undefined && careerLevelEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevelEq, 'CareerLevelEq');
    }
    if (careerLevelShort !== undefined && careerLevelShort !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>careerLevelShort,
        'CareerLevelShort'
      );
    }
    if (careerLevelShortEq !== undefined && careerLevelShortEq !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>careerLevelShortEq,
        'CareerLevelShortEq'
      );
    }
    if (partialJobCode !== undefined && partialJobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>partialJobCode, 'PartialJobCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/field-values-with-description`;
    return this.httpClient.request<SharedPageModelOfSharedFieldValueWithDescriptionModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all job code values for provided query criteria.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryJobProfileValuesMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryJobProfileValuesMercerJobCodesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerJobCodesJobProfileValuesModel>;
  public queryJobProfileValuesMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryJobProfileValuesMercerJobCodesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerJobCodesJobProfileValuesModel>>;
  public queryJobProfileValuesMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryJobProfileValuesMercerJobCodesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerJobCodesJobProfileValuesModel>>;
  public queryJobProfileValuesMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryJobProfileValuesMercerJobCodesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const jobCode = requestParameters?.jobCode;
    const family = requestParameters?.family;
    const familyEq = requestParameters?.familyEq;
    const familyCode = requestParameters?.familyCode;
    const subFamily = requestParameters?.subFamily;
    const subFamilyEq = requestParameters?.subFamilyEq;
    const subFamilyCode = requestParameters?.subFamilyCode;
    const specialization = requestParameters?.specialization;
    const specializationEq = requestParameters?.specializationEq;
    const specializationCode = requestParameters?.specializationCode;
    const careerStream = requestParameters?.careerStream;
    const careerStreamEq = requestParameters?.careerStreamEq;
    const careerLevel = requestParameters?.careerLevel;
    const careerLevelEq = requestParameters?.careerLevelEq;
    const careerLevelShort = requestParameters?.careerLevelShort;
    const careerLevelShortEq = requestParameters?.careerLevelShortEq;
    const partialJobCode = requestParameters?.partialJobCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (jobCode !== undefined && jobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCode, 'JobCode');
    }
    if (family !== undefined && family !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>family, 'Family');
    }
    if (familyEq !== undefined && familyEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyEq, 'FamilyEq');
    }
    if (familyCode !== undefined && familyCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyCode, 'FamilyCode');
    }
    if (subFamily !== undefined && subFamily !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamily, 'SubFamily');
    }
    if (subFamilyEq !== undefined && subFamilyEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyEq, 'SubFamilyEq');
    }
    if (subFamilyCode !== undefined && subFamilyCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyCode, 'SubFamilyCode');
    }
    if (specialization !== undefined && specialization !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>specialization, 'Specialization');
    }
    if (specializationEq !== undefined && specializationEq !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationEq,
        'SpecializationEq'
      );
    }
    if (specializationCode !== undefined && specializationCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationCode,
        'SpecializationCode'
      );
    }
    if (careerStream !== undefined && careerStream !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStream, 'CareerStream');
    }
    if (careerStreamEq !== undefined && careerStreamEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStreamEq, 'CareerStreamEq');
    }
    if (careerLevel !== undefined && careerLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevel, 'CareerLevel');
    }
    if (careerLevelEq !== undefined && careerLevelEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevelEq, 'CareerLevelEq');
    }
    if (careerLevelShort !== undefined && careerLevelShort !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>careerLevelShort,
        'CareerLevelShort'
      );
    }
    if (careerLevelShortEq !== undefined && careerLevelShortEq !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>careerLevelShortEq,
        'CareerLevelShortEq'
      );
    }
    if (partialJobCode !== undefined && partialJobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>partialJobCode, 'PartialJobCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/job-profile-values`;
    return this.httpClient.request<EmployeesMercerJobCodesJobProfileValuesModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all assignments.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryMercerJobCodeAssignmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesMercerJobCodeAssignmentsMercerEmployeesWithAssignmentsModel>;
  public queryMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryMercerJobCodeAssignmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesMercerJobCodeAssignmentsMercerEmployeesWithAssignmentsModel>>;
  public queryMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryMercerJobCodeAssignmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesMercerJobCodeAssignmentsMercerEmployeesWithAssignmentsModel>>;
  public queryMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceQueryMercerJobCodeAssignmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;
    const lastname = requestParameters?.lastname;
    const firstname = requestParameters?.firstname;
    const orgCodes = requestParameters?.orgCodes;
    const orgSizes = requestParameters?.orgSizes;
    const countries = requestParameters?.countries;
    const areCodes = requestParameters?.areCodes;
    const jobCodes = requestParameters?.jobCodes;
    const familyNames = requestParameters?.familyNames;
    const subFamilyNames = requestParameters?.subFamilyNames;
    const specializationNames = requestParameters?.specializationNames;
    const careerLevelNames = requestParameters?.careerLevelNames;
    const careerStreams = requestParameters?.careerStreams;
    const positionClasses = requestParameters?.positionClasses;
    const internalLevels = requestParameters?.internalLevels;
    const jobCodeValidFrom = requestParameters?.jobCodeValidFrom;
    const jobCodeValidTo = requestParameters?.jobCodeValidTo;
    const jobCodeIsValidated = requestParameters?.jobCodeIsValidated;
    const positionClassValidFrom = requestParameters?.positionClassValidFrom;
    const positionClassValidTo = requestParameters?.positionClassValidTo;
    const positionClassIsValidated = requestParameters?.positionClassIsValidated;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (orgCodes) {
      orgCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodes');
      });
    }
    if (orgSizes) {
      orgSizes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSizes');
      });
    }
    if (countries) {
      countries.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Countries');
      });
    }
    if (areCodes) {
      areCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCodes');
      });
    }
    if (jobCodes) {
      jobCodes.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'JobCodes');
      });
    }
    if (familyNames) {
      familyNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'FamilyNames');
      });
    }
    if (subFamilyNames) {
      subFamilyNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SubFamilyNames');
      });
    }
    if (specializationNames) {
      specializationNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SpecializationNames');
      });
    }
    if (careerLevelNames) {
      careerLevelNames.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CareerLevelNames');
      });
    }
    if (careerStreams) {
      careerStreams.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CareerStreams');
      });
    }
    if (positionClasses) {
      positionClasses.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClasses');
      });
    }
    if (internalLevels) {
      internalLevels.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'InternalLevels');
      });
    }
    if (jobCodeValidFrom !== undefined && jobCodeValidFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>jobCodeValidFrom,
        'JobCodeValidFrom'
      );
    }
    if (jobCodeValidTo !== undefined && jobCodeValidTo !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCodeValidTo, 'JobCodeValidTo');
    }
    if (jobCodeIsValidated) {
      jobCodeIsValidated.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'JobCodeIsValidated');
      });
    }
    if (positionClassValidFrom !== undefined && positionClassValidFrom !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionClassValidFrom,
        'PositionClassValidFrom'
      );
    }
    if (positionClassValidTo !== undefined && positionClassValidTo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionClassValidTo,
        'PositionClassValidTo'
      );
    }
    if (positionClassIsValidated) {
      positionClassIsValidated.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'PositionClassIsValidated'
        );
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/assignments`;
    return this.httpClient.request<SharedPageModelOfEmployeesMercerJobCodeAssignmentsMercerEmployeesWithAssignmentsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all available mercer job codes.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryMercerJobCodesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesMercerJobCodesMercerJobCodeModel>;
  public queryMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryMercerJobCodesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesMercerJobCodesMercerJobCodeModel>>;
  public queryMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryMercerJobCodesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesMercerJobCodesMercerJobCodeModel>>;
  public queryMercerJobCodes(
    requestParameters?: EmployeesAdminServiceQueryMercerJobCodesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const jobCode = requestParameters?.jobCode;
    const family = requestParameters?.family;
    const familyEq = requestParameters?.familyEq;
    const familyCode = requestParameters?.familyCode;
    const subFamily = requestParameters?.subFamily;
    const subFamilyEq = requestParameters?.subFamilyEq;
    const subFamilyCode = requestParameters?.subFamilyCode;
    const specialization = requestParameters?.specialization;
    const specializationEq = requestParameters?.specializationEq;
    const specializationCode = requestParameters?.specializationCode;
    const careerStream = requestParameters?.careerStream;
    const careerStreamEq = requestParameters?.careerStreamEq;
    const careerLevel = requestParameters?.careerLevel;
    const careerLevelEq = requestParameters?.careerLevelEq;
    const careerLevelShort = requestParameters?.careerLevelShort;
    const careerLevelShortEq = requestParameters?.careerLevelShortEq;
    const partialJobCode = requestParameters?.partialJobCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (jobCode !== undefined && jobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCode, 'JobCode');
    }
    if (family !== undefined && family !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>family, 'Family');
    }
    if (familyEq !== undefined && familyEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyEq, 'FamilyEq');
    }
    if (familyCode !== undefined && familyCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>familyCode, 'FamilyCode');
    }
    if (subFamily !== undefined && subFamily !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamily, 'SubFamily');
    }
    if (subFamilyEq !== undefined && subFamilyEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyEq, 'SubFamilyEq');
    }
    if (subFamilyCode !== undefined && subFamilyCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subFamilyCode, 'SubFamilyCode');
    }
    if (specialization !== undefined && specialization !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>specialization, 'Specialization');
    }
    if (specializationEq !== undefined && specializationEq !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationEq,
        'SpecializationEq'
      );
    }
    if (specializationCode !== undefined && specializationCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>specializationCode,
        'SpecializationCode'
      );
    }
    if (careerStream !== undefined && careerStream !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStream, 'CareerStream');
    }
    if (careerStreamEq !== undefined && careerStreamEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerStreamEq, 'CareerStreamEq');
    }
    if (careerLevel !== undefined && careerLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevel, 'CareerLevel');
    }
    if (careerLevelEq !== undefined && careerLevelEq !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>careerLevelEq, 'CareerLevelEq');
    }
    if (careerLevelShort !== undefined && careerLevelShort !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>careerLevelShort,
        'CareerLevelShort'
      );
    }
    if (careerLevelShortEq !== undefined && careerLevelShortEq !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>careerLevelShortEq,
        'CareerLevelShortEq'
      );
    }
    if (partialJobCode !== undefined && partialJobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>partialJobCode, 'PartialJobCode');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes`;
    return this.httpClient.request<SharedPageModelOfEmployeesMercerJobCodesMercerJobCodeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all existing security settings.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySecuritySettings(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<EmployeesSecuritySettingsSecuritySettingsModel>>;
  public querySecuritySettings(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<EmployeesSecuritySettingsSecuritySettingsModel>>>;
  public querySecuritySettings(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<EmployeesSecuritySettingsSecuritySettingsModel>>>;
  public querySecuritySettings(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/security-settings`;
    return this.httpClient.request<Array<EmployeesSecuritySettingsSecuritySettingsModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Recalculate RuleBasedAccessFilter
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateRuleBasedAccessFilterRuleBasedAccessFilter(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<string>;
  public recalculateRuleBasedAccessFilterRuleBasedAccessFilter(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<string>>;
  public recalculateRuleBasedAccessFilterRuleBasedAccessFilter(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<string>>;
  public recalculateRuleBasedAccessFilterRuleBasedAccessFilter(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/rule-based-access-filters/recalculate`;
    return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Gets all existing security settings.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateSecuritySettings(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData>;
  public recalculateSecuritySettings(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData>>;
  public recalculateSecuritySettings(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData>>;
  public recalculateSecuritySettings(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/security-settings/recalculation`;
    return this.httpClient.request<TransactionStatusOfEmployeeSecuritySettingsRecalculationMetaData>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing employees by provided criteria, filtered by excluding some gids.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public searchEmployeesEmployees(
    requestParameters?: EmployeesAdminServiceSearchEmployeesEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeModel>;
  public searchEmployeesEmployees(
    requestParameters?: EmployeesAdminServiceSearchEmployeesEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public searchEmployeesEmployees(
    requestParameters?: EmployeesAdminServiceSearchEmployeesEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public searchEmployeesEmployees(
    requestParameters?: EmployeesAdminServiceSearchEmployeesEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const employeesEmployeesQueryEmployeesWithExcludableGidsParameter =
      requestParameters?.employeesEmployeesQueryEmployeesWithExcludableGidsParameter;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/search`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesEmployeesQueryEmployeesWithExcludableGidsParameter,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Simulates a population of employees based on provided ruleset.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulatePopulationBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceSimulatePopulationBenchmarkSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeModel>;
  public simulatePopulationBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceSimulatePopulationBenchmarkSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public simulatePopulationBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceSimulatePopulationBenchmarkSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public simulatePopulationBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceSimulatePopulationBenchmarkSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling simulatePopulationBenchmarkSettings.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/benchmarks/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a new security settings population simulation.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulatePopulationSecuritySettings(
    requestParameters?: EmployeesAdminServiceSimulatePopulationSecuritySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesSecuritySettingsPopulationSimulationPageModel>;
  public simulatePopulationSecuritySettings(
    requestParameters?: EmployeesAdminServiceSimulatePopulationSecuritySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesSecuritySettingsPopulationSimulationPageModel>>;
  public simulatePopulationSecuritySettings(
    requestParameters?: EmployeesAdminServiceSimulatePopulationSecuritySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesSecuritySettingsPopulationSimulationPageModel>>;
  public simulatePopulationSecuritySettings(
    requestParameters?: EmployeesAdminServiceSimulatePopulationSecuritySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling simulatePopulationSecuritySettings.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/security-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-simulation`;
    return this.httpClient.request<EmployeesSecuritySettingsPopulationSimulationPageModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Unassign RuleBasedAccessFilter from Employee
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: EmployeesAdminServiceUnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: EmployeesAdminServiceUnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: EmployeesAdminServiceUnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee(
    requestParameters?: EmployeesAdminServiceUnassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployeeRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const ruleId = requestParameters?.ruleId;
    if (ruleId === null || ruleId === undefined) {
      throw new Error(
        'Required parameter ruleId was null or undefined when calling unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee.'
      );
    }
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling unassignRuleBasedAccessFilterFromEmployeeRuleBasedAccessFilterEmployee.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/rule-based-access-filters/${this.configuration.encodeParam({ name: 'ruleId', value: ruleId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates an existing are.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAres(
    requestParameters?: EmployeesAdminServiceUpdateAresRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesAresAreModel>;
  public updateAres(
    requestParameters?: EmployeesAdminServiceUpdateAresRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesAresAreModel>>;
  public updateAres(
    requestParameters?: EmployeesAdminServiceUpdateAresRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesAresAreModel>>;
  public updateAres(
    requestParameters?: EmployeesAdminServiceUpdateAresRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeesAresUpdateAreModel = requestParameters?.employeesAresUpdateAreModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/ares`;
    return this.httpClient.request<EmployeesAresAreModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: employeesAresUpdateAreModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Updates existing benchmark settings.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceUpdateBenchmarkSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesBenchmarkSettingsBenchmarkSettingsModel>;
  public updateBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceUpdateBenchmarkSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesBenchmarkSettingsBenchmarkSettingsModel>>;
  public updateBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceUpdateBenchmarkSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesBenchmarkSettingsBenchmarkSettingsModel>>;
  public updateBenchmarkSettings(
    requestParameters?: EmployeesAdminServiceUpdateBenchmarkSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateBenchmarkSettings.');
    }
    const employeesBenchmarkSettingsUpdateBenchmarkSettingsModel =
      requestParameters?.employeesBenchmarkSettingsUpdateBenchmarkSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/benchmarks/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesBenchmarkSettingsBenchmarkSettingsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesBenchmarkSettingsUpdateBenchmarkSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates the employees in company manager and triggers reassignment processing.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeInCompanyManager(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeInCompanyManagerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public updateEmployeeInCompanyManager(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeInCompanyManagerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public updateEmployeeInCompanyManager(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeInCompanyManagerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public updateEmployeeInCompanyManager(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeInCompanyManagerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling updateEmployeeInCompanyManager.'
      );
    }
    const employeesEmployeeInCompanyManagerUpdateEmployeeInCompanyManagerModel =
      requestParameters?.employeesEmployeeInCompanyManagerUpdateEmployeeInCompanyManagerModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/in-company-manager`;
    return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: employeesEmployeeInCompanyManagerUpdateEmployeeInCompanyManagerModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Creates or updates the internal level of an existing employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeInternalLevel(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeInternalLevelRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesEmployeesEmployeeInternalLevelModel>;
  public updateEmployeeInternalLevel(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeInternalLevelRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesEmployeesEmployeeInternalLevelModel>>;
  public updateEmployeeInternalLevel(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeInternalLevelRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesEmployeesEmployeeInternalLevelModel>>;
  public updateEmployeeInternalLevel(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeInternalLevelRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling updateEmployeeInternalLevel.');
    }
    const siemensEnergyCOINClientApiRequestsEmployeesEmployeesUpdateEmployeeInternalLevelCommand =
      requestParameters?.siemensEnergyCOINClientApiRequestsEmployeesEmployeesUpdateEmployeeInternalLevelCommand;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/internal-level`;
    return this.httpClient.request<EmployeesEmployeesEmployeeInternalLevelModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: siemensEnergyCOINClientApiRequestsEmployeesEmployeesUpdateEmployeeInternalLevelCommand,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates the employees line manager and triggers reassignment processing.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeLineManager(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeLineManagerRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public updateEmployeeLineManager(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeLineManagerRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public updateEmployeeLineManager(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeLineManagerRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public updateEmployeeLineManager(
    requestParameters?: EmployeesAdminServiceUpdateEmployeeLineManagerRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling updateEmployeeLineManager.');
    }
    const employeesEmployeeLineManagerUpdateEmployeeLineManagerModel =
      requestParameters?.employeesEmployeeLineManagerUpdateEmployeeLineManagerModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/line-manager`;
    return this.httpClient.request<any>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: employeesEmployeeLineManagerUpdateEmployeeLineManagerModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Sets the internal comment for an existing employee by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateInternalComments(
    requestParameters?: EmployeesAdminServiceUpdateInternalCommentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesInternalCommentsInternalCommentModel>;
  public updateInternalComments(
    requestParameters?: EmployeesAdminServiceUpdateInternalCommentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesInternalCommentsInternalCommentModel>>;
  public updateInternalComments(
    requestParameters?: EmployeesAdminServiceUpdateInternalCommentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesInternalCommentsInternalCommentModel>>;
  public updateInternalComments(
    requestParameters?: EmployeesAdminServiceUpdateInternalCommentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling updateInternalComments.');
    }
    const employeesInternalCommentsUpdateInternalCommentModel =
      requestParameters?.employeesInternalCommentsUpdateInternalCommentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/internal-comment`;
    return this.httpClient.request<EmployeesInternalCommentsInternalCommentModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesInternalCommentsUpdateInternalCommentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates the job code assignment for an employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMercerJobCodeAssignmentMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceUpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerJobCodeAssignmentsMercerJobCodeAssignmentLightModel>;
  public updateMercerJobCodeAssignmentMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceUpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerJobCodeAssignmentsMercerJobCodeAssignmentLightModel>>;
  public updateMercerJobCodeAssignmentMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceUpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerJobCodeAssignmentsMercerJobCodeAssignmentLightModel>>;
  public updateMercerJobCodeAssignmentMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceUpdateMercerJobCodeAssignmentMercerJobCodeAssignmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling updateMercerJobCodeAssignmentMercerJobCodeAssignments.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateMercerJobCodeAssignmentMercerJobCodeAssignments.'
      );
    }
    const employeesMercerJobCodeAssignmentsUpdateMercerJobCodeAssignmentModel =
      requestParameters?.employeesMercerJobCodeAssignmentsUpdateMercerJobCodeAssignmentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/job-code/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesMercerJobCodeAssignmentsMercerJobCodeAssignmentLightModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesMercerJobCodeAssignmentsUpdateMercerJobCodeAssignmentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates the position class assignment for an employee.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMercerPositionClassAssignmentMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceUpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesMercerJobCodeAssignmentsMercerPositionClassAssignmentLightModel>;
  public updateMercerPositionClassAssignmentMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceUpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesMercerJobCodeAssignmentsMercerPositionClassAssignmentLightModel>>;
  public updateMercerPositionClassAssignmentMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceUpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesMercerJobCodeAssignmentsMercerPositionClassAssignmentLightModel>>;
  public updateMercerPositionClassAssignmentMercerJobCodeAssignments(
    requestParameters?: EmployeesAdminServiceUpdateMercerPositionClassAssignmentMercerJobCodeAssignmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling updateMercerPositionClassAssignmentMercerJobCodeAssignments.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateMercerPositionClassAssignmentMercerJobCodeAssignments.'
      );
    }
    const employeesMercerJobCodeAssignmentsUpdateMercerPositionClassAssignmentModel =
      requestParameters?.employeesMercerJobCodeAssignmentsUpdateMercerPositionClassAssignmentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/master/mercer-job-codes/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/position-class/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesMercerJobCodeAssignmentsMercerPositionClassAssignmentLightModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesMercerJobCodeAssignmentsUpdateMercerPositionClassAssignmentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates RuleBasedAccessFilter
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceUpdateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>;
  public updateRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceUpdateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>>;
  public updateRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceUpdateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>>;
  public updateRuleBasedAccessFilterRuleBasedAccessFilter(
    requestParameters?: EmployeesAdminServiceUpdateRuleBasedAccessFilterRuleBasedAccessFilterRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const siemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersUpdateRuleBasedAccessFilterCommand =
      requestParameters?.siemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersUpdateRuleBasedAccessFilterCommand;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/rule-based-access-filters`;
    return this.httpClient.request<EmployeesRuleBasedAccessFiltersRuleBasedAccessFilterModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: siemensEnergyCOINClientApiHandlersEmployeesRuleBasedAccessFiltersUpdateRuleBasedAccessFilterCommand,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates existing security settings by their unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSecuritySettings(
    requestParameters?: EmployeesAdminServiceUpdateSecuritySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesSecuritySettingsSecuritySettingsModel>;
  public updateSecuritySettings(
    requestParameters?: EmployeesAdminServiceUpdateSecuritySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesSecuritySettingsSecuritySettingsModel>>;
  public updateSecuritySettings(
    requestParameters?: EmployeesAdminServiceUpdateSecuritySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesSecuritySettingsSecuritySettingsModel>>;
  public updateSecuritySettings(
    requestParameters?: EmployeesAdminServiceUpdateSecuritySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateSecuritySettings.');
    }
    const employeesSecuritySettingsUpdateSecuritySettingsModel =
      requestParameters?.employeesSecuritySettingsUpdateSecuritySettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v3/master/employees/security-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeesSecuritySettingsSecuritySettingsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: employeesSecuritySettingsUpdateSecuritySettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
